import { render, staticRenderFns } from "./forumdetails.vue?vue&type=template&id=54aef29a&scoped=true&"
import script from "./forumdetails.vue?vue&type=script&lang=js&"
export * from "./forumdetails.vue?vue&type=script&lang=js&"
import style0 from "./forumdetails.vue?vue&type=style&index=0&id=54aef29a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aef29a",
  null
  
)

export default component.exports